// extracted by mini-css-extract-plugin
export default {"importDB":"ImportDB_importDB__zJYs1"};